import React from 'react';
import { Outlet, useRoutes } from 'react-router-dom';
import Navigation from './Navigation';
import Dashboard from '../PHPComponents/Dashboard';
import FirmEntry from './Master/FirmEntry';
import FirmTable from './MasterTables/FirmTable/FirmTable';
import FirmEdit from './MasterEdit/FirmEdit';
import EmployeeEntry from './Master/EmployeeEntry';
import EmpTable from './MasterTables/EmployeeTable/EmpTable';
import EmployeeEdit from './MasterEdit/EmployeeEdit';
import DepartmentEntry from './Master/DepartmentEntry';
import DepartmentTable from './MasterTables/DepartmentTable/DepartmentTable';
import DepartmentEdit from './MasterEdit/DepartmentEdit';
import PannaEntry from './Master/PannaEntry';
import PannaTable from './MasterTables/PannaTable/PannaTable';
import PannaEdit from './MasterEdit/PannaEdit';
import ClothEntry from './Master/ClothEntry';
import ClothTable from './MasterTables/ClothTable/ClothTable';
import ClothEdit from './MasterEdit/ClothEdit';
import SalePurchaseEntry from './Master/SalePurchaseEntry';
import SalePurchaseTbl from './MasterTables/SalePurchaseTable/SalePurchaseTbl';
import SalePurchaseEdit from './MasterEdit/SalePurchaseEdit';
import ItemMaster from './Master/ItemMaster';
import ItemTbl from './MasterTables/ItemTable/ItemTbl';
import ItemEdit from './MasterEdit/ItemEdit';
import PannaItemAverage from './Master/PannaItemAverage';
import RackEntry from './Master/RackEntry';
import RackTable from './MasterTables/RackTbl/RackTable';
import RackEdit from './MasterEdit/RackEdit';
import SchoolEntry from './Master/SchoolEntry';
import SchoolEdit from './MasterEdit/SchoolEdit';
import SchoolTable from './MasterTables/SchlTable/SchoolTable';
import TransportEntry from './Master/TransportEntry';
import TransportTable from './MasterTables/TransportTbl/TransportTable';
import TransportEdit from './MasterEdit/TransportEdit';
import LogoEntry from './Master/LogoEntry';
import LogoTable from './MasterTables/LogoTbl/LogoTable';
import LogoEdit from './MasterEdit/LogoEdit';
import MaterialEntry from './Master/MaterialEntry';
import MaterialTable from './MasterTables/MaterialTbl/MaterialTable';
import MaterialEdit from './MasterEdit/MaterialEdit';
import MatInwardEntry from './Master/MatInwardEntry';
import MatOutwardEntry from './Master/MatOutwardEntry';
import MatInwardTable from './MasterTables/MatInwardTbl/MatInwardTable';
import MatOutwardTable from './MasterTables/MatOutwardTbl/MatOutwardTable';
import ClothStkEntry from './UploadStock/ClothStkEntry';
import MatInwardEdit from './MasterEdit/MatInwardEdit';
import MatOutwardEdit from './MasterEdit/MatOutwardEdit';
import ReadyMStkEntry from './UploadStock/ReadyMStkEntry';
import ClothStkTable from './UploadStkTable/ClothStkTbl/ClothStkTable';
import ClothStkEdit from './UploadStkEdit/ClothStkEdit';
import ReadyMStkTable from './UploadStkTable/ReadyMStkTbl/ReadyMStkTable';
import ReadyMStkEdit from './UploadStkEdit/ReadyMStkEdit';
import PricePercentGEntry from './Sale/PricePercentGEntry';
import PurchaseOrderEntry from './Purchase/PurchaseOrderEntry';
import JobRateEntry from './Master/JobRateEntry';
import JobRateTable from './MasterTables/JobRateTbl/JobRateTable';
import PricePercentTable from './SaleTables/PricePercentTbl/PricePerTable';
import PurchaseInwardEntry from './Inward/PurchaseInwardEntry';
import NewItemEntry from './NewEntry/NewItemEntry';
import NewClothEntry from './NewEntry/NewClothEntry';
import PurchaseOrderTable from './PurchaseTables/PurchaseOrderTbl/PurchaseOrderTable';
import POExtraEntry from './Purchase/POExtraEntry';
import DirectPurchaseInwEntry from './Inward/DirectPIEntry';
import PurInwardTable from './InwardTables/PurchaseInwardTbl/PurInwardTable';
import NewPartyEntry from './NewEntry/NewPartyEntry';
import QuotationEntry from './Sale/QuotationEntry';
import NewSchoolEntry from './NewEntry/NewSchoolEntry';
import QuotationTable from './SaleTables/QuotationTbl/QuotationTable';
import SaleOrder from './Sale/SaleOrder';
import NewLogoEntry from './NewEntry/NewLogoEntry';
import NewTransportEntry from './NewEntry/NewTransportEntry';
import SaleOrderTable from './SaleTables/SaleOrdTbl/SaleOrderTable';
import SaleOrderRate from './Sale/SORate';
import SORateManually from './Sale/SORateManually';
import SOWiseEntry from './CuttingMukul/SOWiseEntry';
import CutManuallyEntry from './CuttingMukul/CutManuallyEntry';
import QuotationView from './Sale/View/QuotationView';
import QuotationInfo from './SaleTables/View/QuotationInfo';
import QuotPrint from './SaleTables/View/QuotPrint';
import RateChange from './SaleTables/View/RateChange';
import RateAnalysis from './SaleTables/View/RateAnalysis';
import SOqtwise from './Sale/SOqtwise';
import DirectSO from './Sale/DirectSO';
import SOInfo from './SaleTables/View/SOInfo';
import CategoryEntry from './WorkerMaster/CategoryEntry';
import CutSOwise from './Cutting/CutSOwise';
import ClothIssueEntry from './Cutting/ClothIssueEntry';
import ClothIssueReg from './CuttingTable/ClothIssueTbl/ClothIssueReg';
import ClothIssueView from './CuttingTable/View/ClothIssueView';
import CuttingEntry from './Cutting/CuttingEntry';
import CuttingRegister from './CuttingTable/CuttingTbl/CuttingRegister';
import CuttingInfoView from './CuttingTable/View/CuttingInfoView';
import CuttingInward from './Cutting/CuttingInward';
import ContractorEntry from './Cutting/ContractorEntry';
import ContractorInward from './Cutting/ContractorInward';
import ContractorReg from './CuttingTable/ContractorTbl/ContractorReg';
import CuttingReturnReg from './CuttingTable/CutReturnTbl/CuttingReturnReg';
import ContractorReturnReg from './CuttingTable/ContractorReturnTbl/ContractorReturnReg';
import CutReturnInfo from './CuttingTable/View/CutReturnInfo';
import ContReturnInfo from './CuttingTable/View/ContReturnInfo';
import StitchInhouseEntry from './Stitching/StitchInhouseEntry';
import ClothIssueEdit from './CuttingEdit/ClothIssueEdit';
import MainReturnInfo from './CuttingTable/View/MainReturnInfo';
import MainContReturnInfo from './CuttingTable/View/MainContReturnInfo';
import SaleOrderEdit from './SaleEdit/SaleOrderEdit';
import CuttingInEdit from './CuttingEdit/CuttingInEntryEdit';
import CuttingFinalPrint from './CuttingTable/View/CutFinalPrint';
import ContCutFinalPrint from './CuttingTable/View/ContFinalPrint';
import StitchingReg from './StitchingTbl/StitchRegister/StitchingReg';
import StitchingInfo from './StitchingTbl/View/StitchingInfo';
import StitchingReturn from './Stitching/StitchingReturn';
import StitchReturnReg from './StitchingTbl/StitchReturn/StitchReturnReg';
import KajeEntry from './Kaje/KajeEntry';
import KajeRegister from './KajeTbl/KajeTable/KajeRegister';
import KajeInfo from './KajeTbl/View/KajeInfo';
import PressingEntry from './Press/PressingEntry';
import KjPrIssueInw from './KPIssueinward/KjPrIssueInw';
import StockEntryProduction from './Stock/StockEntryProduction';
import StitchContractorEntry from './Stitching/StitchContractorEntry';
import StitchContractorReg from './StitchingTbl/StichContractorTbl/StitchContractorReg';
import StitchContraInfo from './StitchingTbl/View/StitchContraInfo';
import StitchContraReturn from './Stitching/StitchContraReturn';
import StContraReturnReg from './StitchingTbl/StitchContraReturn/StContraReturnReg';
import StitchingUpdate from './StitchingEdit/StitchingUpdate';
import KajeRegProduction from './KPIssueinwardTbl/KajeRegTable/KajeRegProduction';
import KajeProductionInfo from './KPIssueinwardTbl/View/KajeProductionInfo';
import StitchReturnInfo from './StitchingTbl/View/StitchReturnInfo';
import PressRegProduction from './KPIssueinwardTbl/PressRegTbl/PressRegProduction';
import PressProdInfo from './KPIssueinwardTbl/View/PressProdInfo';
import StContReturnInfo from './StitchingTbl/View/StContReturnInfo';
import StkProductionEntry from './Stock/StkProductionEntry';
import StkProductionReg from './StockTable/StkProductinTbl/StkProductionReg';
import StkProductionEdit from './StockEdit/StkProductionEdit';
import PackingEntry from './Packing/PackingEntry';
import PackingRegister from './PackingTables/PackingReg/PackingRegister';
import PackPrintStruct from './FieldsComponents/PackPrintStruct';
import PackingPrint from './PackingTables/View/PackingPrint';
import PackingEdit from './Packing/PackingEdit';
import InvoiceEntry from './Invoice/InvoiceEntry';
import InvoiceRegister from './InvoiceTbl/InvoiceTable/InvoiceRegister';
import PackingSlipRegister from './PackingTables/PackingSlipReg/PackingSlipRegister';
import SaleInvoice from './Packing/SaleInvoice';
import SaleInvoiceRegister from './PackingTables/InvoiceDetails/SaleInvoiceReg';
import CthIssueView from './Cutting/View/CthIssueView';
import CuttingEntry2 from './Cutting/CuttingEntry2';
import BaleLump from './Inward/BaleLump';
import PIView from './Inward/PIView';
import BaleLumpView from './Inward/BaleLumpView';
import LumpMtrTbl2 from './UploadStock/LumpMtrTbl2';
import ClothStkView from './UploadStkTable/ClothStkTbl/ClothStkView';
import ClothIssueLump from './Cutting/ClothIssueLump';
import ClothIssueReturn from './CuttingTable/ClothIssueTbl/ClothIssueReturn';
import BrandEntry from './Master/BrandEntry';
import BrandEdit from './MasterEdit/BrandEdit';
import ItemMaterial from './Master/ItemMaterial';
import ItemMaterialReg from './MasterTables/ItemMaterialTbl/ItemMaterialReg';
import MaterialView from './MasterTables/ItemMaterialTbl/MaterialView';
import ItemMaterialEdit from './MasterEdit/ItemMaterialEdit';
import CuttingItemView from './Cutting/View/CuttingItemView';
import LoginPage from './LoginPage';
import PartyInward from './PartyInw/PartyInward';
import PartyInwRegister from './PartyInwTbl/PartyInwReg/PartyInwRegister';
import PartyInwView from './PartyInwTbl/PartyInwReg/PartyInwView';
import JobRateView from './MasterTables/JobRateTbl/JobRateView';
import JobRateEdit from './MasterEdit/JobRateEdit';
import StitchFinalReturnInfo from './StitchingTbl/View/StitchFInalReturn';
import PartyInwEdit from './PartyInw/PartyInwEdit';
import EmpJobwork from './Jobwork/EmpJobwork';
import PartyInwardView from './PartyInw/PartyInwardView';
import AdvancePayment from './Jobwork/AdvancePayment';
import JobworkPaymentReg from './JobworkTbl/JobworkPaymentTbl/JobworkPaymentReg';
import JobwkPayView from './JobworkTbl/JobworkPaymentTbl/JobwkPayView';
import PaymentEntry from './Jobwork/PaymentEntry';
import PaymentRegister from './JobworkTbl/PaymentTbl/PaymentRegister';
import PaymentView from './JobworkTbl/PaymentTbl/PaymentView';


export default function Router() {
    const stockdata = {
        title: 'Ready Made Stock Entry',
        regTitle: 'Ready Made Stock Register',
        editTitle: 'Ready Made Stock Edit',
        editPath: 'ReadyMStkEdit',
        menu: [
            {
                title: 'Ready Made Stock',
                path: '/ReadyMStkEntry'
            },
            {
                title: 'Ready Made Stock Register',
                path: '/ReadyMStkTable'
            }
        ]
    };
    const manualdata = {
        title: 'Manual Stock Entry',
        regTitle: 'Manual Stock Register',
        editTitle: 'Manual Stock Edit',
        editPath: 'Manual-StockEdit',
        menu: [
            {
                title: 'Stock Production Entry',
                path: '/StkProductionEntry'
            },
            {
                title: 'Stock Register',
                path: '/StkProductionRegister'
            },
            {
                title: 'Manual Stock Entry',
                path: '/Manual-stock'
            },
            {
                title: 'Manual Stock Register',
                path: '/Manual-StockReg'
            }
        ]
    }
    const mainRoutes = useRoutes([
        {
            index: true,
            element: <Dashboard />
        },
        { element: <LoginPage />, path: 'login-production' },
        {
            element: (
                <Navigation>
                    <Outlet />
                </Navigation>
            ),
            children: [

                // { path: 'FirmEntry', element: <FirmEntry /> },
                // { path: 'FirmTable', element: <FirmTable /> },
                // { path: 'FirmEdit/:Id', element: <FirmEdit /> },
                { path: 'EmployeeEntry', element: <EmployeeEntry /> },
                { path: 'EmployeeTable', element: <EmpTable /> },
                { path: 'DepartmentEntry', element: <DepartmentEntry /> },
                { path: 'DepartmentTable', element: <DepartmentTable /> },
                { path: 'DepartmentEdit/:Id', element: <DepartmentEdit /> },
                // { path: 'PannaEntry', element: <PannaEntry /> },
                // { path: 'PannaTable', element: <PannaTable /> },
                // { path: 'PannaEdit/:Id', element: <PannaEdit /> },
                // { path: 'ClothEntry', element: <ClothEntry /> },
                // { path: 'ClothTable', element: <ClothTable /> },
                // { path: 'ClothEdit/:Id', element: <ClothEdit /> },
                { path: 'SalePurchaseEntry', element: <SalePurchaseEntry /> },
                { path: 'SalePurchaseTable', element: <SalePurchaseTbl /> },
                { path: 'SalePurchaseEdit/:Id', element: <SalePurchaseEdit /> },
                { path: 'ItemEntry', element: <ItemMaster /> },
                { path: 'ItemTable', element: <ItemTbl /> },
                { path: 'ItemEdit/:Id', element: <ItemEdit /> },
                // { path: 'ItemAverageMaster', element: <PannaItemAverage /> },
                { path: 'JobRateEntry', element: <JobRateEntry /> },
                { path: 'JobRateTable', element: <JobRateTable /> },
                // { path: 'RackEntry', element: <RackEntry /> },
                // { path: 'RackTable', element: <RackTable /> },
                // { path: 'RackEdit/:Id', element: <RackEdit /> },
                // { path: 'SchoolEntry', element: <SchoolEntry /> },
                // { path: 'SchoolTable', element: <SchoolTable /> },
                // { path: 'SchoolEdit/:Id', element: <SchoolEdit /> },
                // { path: 'TransportEntry', element: <TransportEntry /> },
                // { path: 'TransportTable', element: <TransportTable /> },
                // { path: 'TransportEdit/:Id', element: <TransportEdit /> },
                // { path: 'LogoEntry', element: <LogoEntry /> },
                // { path: 'LogoTable', element: <LogoTable /> },
                // { path: 'LogoEdit/:Id', element: <LogoEdit /> },
                { path: 'MaterialEntry', element: <MaterialEntry /> },
                { path: 'MaterialTable', element: <MaterialTable /> },
                { path: 'MaterialEdit/:Id', element: <MaterialEdit /> },
                { path: 'MaterialInwardEntry', element: <MatInwardEntry /> },
                { path: 'MaterialInwardTable', element: <MatInwardTable /> },
                { path: 'MaterialInwardEdit/:Id', element: <MatInwardEdit /> },
                { path: 'MaterialOutwardEntry', element: <MatOutwardEntry /> },
                { path: 'MaterialOutwardTable', element: <MatOutwardTable /> },
                { path: 'MaterialOutwardEdit/:Id', element: <MatOutwardEdit /> },
                // { path: 'ClothStkEntry', element: <ClothStkEntry /> },
                // { path: 'ClothStkTable', element: <ClothStkTable /> },
                // { path: 'ReadyMStkEntry', element: <ReadyMStkEntry data={stockdata} /> },
                // { path: 'ReadyMStkTable', element: <ReadyMStkTable data={stockdata} /> },
                // { path: 'Manual-stock', element: <ReadyMStkEntry data={manualdata} /> },
                // { path: 'Manual-StockReg', element: <ReadyMStkTable data={manualdata} /> },
                // { path: 'PricePercentGEntry', element: <PricePercentGEntry /> },
                // { path: 'PricePerGrpTable', element: <PricePercentTable /> },
                // { path: 'PurchaseOrderEntry', element: <PurchaseOrderEntry /> },
                // { path: 'PurchaseOrderTable', element: <PurchaseOrderTable /> },
                // { path: 'POExtraEntry', element: <POExtraEntry /> },
                // { path: 'PurchaseInwardEntry', element: <PurchaseInwardEntry /> },
                // { path: 'DirectPurchaseInwardEntry', element: <DirectPurchaseInwEntry /> },
                // { path: 'PurchaseInwardTable', element: <PurInwardTable /> },
                // { path: 'NewItemEntry', element: <NewItemEntry /> },
                // { path: 'NewClothEntry', element: <NewClothEntry /> },
                // { path: 'NewPartyEntry', element: <NewPartyEntry /> },
                // { path: 'quotationentry', element: <QuotationEntry /> },
                // { path: 'QuotationTable', element: <QuotationTable /> },
                // { path: 'NewSchoolEntry', element: <NewSchoolEntry /> },
                // { path: 'SaleOrder', element: <SaleOrder /> },
                // { path: 'NewLogoEntry', element: <NewLogoEntry /> },
                // { path: 'NewTransportEntry', element: <NewTransportEntry /> },
                // { path: 'SaleOrderTable', element: <SaleOrderTable /> },
                // { path: 'SaleOrderRate', element: <SaleOrderRate /> },
                // { path: 'SORateManually', element: <SORateManually /> },
                // { path: 'SOWiseEntry', element: <SOWiseEntry /> },
                // { path: 'CuttingManuallyEntry', element: <CutManuallyEntry /> },
                // { path: 'QuotationInfo/:Id', element: <QuotationInfo /> },
                // { path: 'QuotPrint/:Id', element: <QuotPrint /> },
                // { path: 'RateChange/:Id', element: <RateChange /> },
                // { path: 'RateAnalysis/:Id', element: <RateAnalysis /> },
                // { path: 'SOQTwise', element: <SOqtwise /> },
                // { path: 'DirectSO', element: <DirectSO /> },
                // { path: 'CategoryMaster', element: <CategoryEntry /> },
                // { path: 'CuttingSOwise', element: <CutSOwise /> },
                // { path: 'ClothIssueEntry', element: <ClothIssueEntry /> },
                // { path: 'ClothIssueReg', element: <ClothIssueReg /> },
                // { path: 'ClothIssueEdit/:Id', element: <ClothIssueEdit /> },
                // { path: 'CuttingEntry', element: <CuttingEntry /> },
                // { path: 'CuttingRegister', element: <CuttingRegister /> },
                // { path: 'CuttingInfoView/:Id', element: <CuttingInfoView /> },
                // { path: 'ContractorEntry', element: <ContractorEntry /> },
                // { path: 'ContractorRegister', element: <ContractorReg /> },
                // { path: 'CuttingReturnRegister', element: <CuttingReturnReg /> },
                // { path: 'ContractorReturnRegister', element: <ContractorReturnReg /> },
                { path: 'StitchInhouseEntry', element: <StitchInhouseEntry /> },
                { path: 'StitchingRegister', element: <StitchingReg /> },
                { path: 'StitchContractorEntry', element: <StitchContractorEntry /> },
                { path: 'StitchContraInfo/:Id', element: <StitchContraInfo /> },
                { path: 'StitchContraReturn/:Id', element: <StitchContraReturn /> },
                { path: 'StitchingReturnRegister', element: <StitchReturnReg /> },
                { path: 'StitchingContractorReturnRegister', element: <StContraReturnReg /> },
                { path: 'StitchingContractor-ReturnInfo/:Id', element: <StContReturnInfo /> },
                { path: 'KajeEntry', element: <KajeEntry /> },
                { path: 'KajeRegister', element: <KajeRegister /> },
                { path: 'KajeInfo/:Id', element: <KajeInfo /> },
                { path: 'PressEntry', element: <PressingEntry /> },
                { path: 'Kaje-PressIssueInward', element: <KjPrIssueInw /> },
                { path: 'StockEntry-Production', element: <StockEntryProduction /> },
                { path: 'KajeRegister-Production', element: <KajeRegProduction /> },
                { path: 'KajeProductionInfo/:Id', element: <KajeProductionInfo /> },
                { path: 'PressRegister-Production', element: <PressRegProduction /> },
                { path: 'PressProductionInfo/:Id', element: <PressProdInfo /> },
                { path: 'StkProductionEntry', element: <StkProductionEntry /> },
                { path: 'StkProductionRegister', element: <StkProductionReg /> },
                // { path: 'packing-entry', element: <PackingEntry /> },
                // { path: 'packing-register', element: <PackingRegister /> },
                // { path: 'packing-slip-register', element: <PackingSlipRegister /> },
                // { path: 'sale-invoice-register', element: <SaleInvoiceRegister /> },
                // { path: 'PrintSturcture', element: <PackPrintStruct /> },
                // { path: 'invoice-entry', element: <InvoiceEntry /> },
                // { path: 'invoice-register', element: <InvoiceRegister /> },
                // { path: 'cutting-entry', element: <CuttingEntry2 /> },
                { path: 'brand-entry', element: <BrandEntry /> },
                { path: 'item-material', element: <ItemMaterial /> },
                { path: 'item-material-reg', element: <ItemMaterialReg /> },
                { path: 'party-inward', element: <PartyInward /> },
                { path: 'party-inward-reg', element: <PartyInwRegister /> },
                { path: 'jobwork-entry', element: <EmpJobwork /> },
                { path: 'advance-payment', element: <AdvancePayment /> },
                { path: 'jobwork-payment-register', element: <JobworkPaymentReg /> },
                { path: 'payment-register', element: <PaymentRegister /> }
            ]
        },
        // { path: 'FirmEdit/:Id', element: <FirmEdit /> },
        { path: 'CuttingInward/:Id', element: <CuttingInward /> },
        { path: 'StkProductionEdit/:Id', element: <StkProductionEdit /> },
        { path: 'ReadyMStkEdit/:Id', element: <ReadyMStkEdit data={stockdata} /> },
        { path: 'Manual-StockEdit/:Id', element: <ReadyMStkEdit data={manualdata} /> },
        { path: 'packing-print/:Id', element: <PackingPrint /> },
        { path: 'packing-edit/:Id', element: <PackingEdit /> },
        { path: 'CuttingMainReturn/:Id', element: <MainReturnInfo /> },
        { path: 'CuttingReturnInfo/:Id', element: <CutReturnInfo /> },
        { path: 'CuttingFinalPrint/:Id', element: <CuttingFinalPrint /> },
        { path: 'ContractorInward/:Id', element: <ContractorInward /> },
        { path: 'CuttingMainContReturn/:Id', element: <MainContReturnInfo /> },
        { path: 'ContractorReturnInfo/:Id', element: <ContReturnInfo /> },
        { path: 'ContCutFinalPrint/:Id', element: <ContCutFinalPrint /> },
        { path: 'packing-sale-invoice/:Id', element: <SaleInvoice /> },
        { path: 'CuttingInEdit/:Id', element: <CuttingInEdit /> },
        { path: 'SOinfo/:Id', element: <SOInfo /> },
        { path: 'SaleOrderEdit/:Id', element: <SaleOrderEdit /> },
        { path: 'StitchingEdit/:Id', element: <StitchingUpdate /> },
        { path: 'ClothStkEdit/:Id', element: <ClothStkEdit /> },
        { path: 'QuotationView', element: <QuotationView /> },
        { path: 'cloth-issue-view', element: <CthIssueView /> },
        { path: 'ClothIssueView/:Id', element: <ClothIssueView /> },
        { path: 'BaleLumpEntry/:Id', element: <BaleLump /> },
        { path: 'PIview/:Id', element: <PIView /> },
        { path: 'BaleLumpView', element: <BaleLumpView /> },
        { path: 'LumpMtrEntry2/:Id', element: <LumpMtrTbl2 /> },
        { path: 'ClothStkView/:Id', element: <ClothStkView data={0} /> },
        { path: 'ClothIssueLump/:Id', element: <ClothIssueLump /> },
        { path: 'ClothIssueLumpsView/:Id', element: <ClothStkView data={1} /> },
        { path: 'ClothIssueReturn/:Id', element: <ClothIssueReturn /> },
        { path: 'brand-edit/:Id', element: <BrandEdit /> },
        { path: 'material-view/:Id', element: <MaterialView /> },
        { path: 'item-material-edit/:Id', element: <ItemMaterialEdit /> },
        { path: 'cutting-item-view', element: <CuttingItemView /> },
        { path: 'new-party-entry', element: <SalePurchaseEntry data={1} /> },
        { path: 'new-brand-entry', element: <BrandEntry data={1} /> },
        { path: 'new-item-entry', element: <ItemMaster data={1} /> },
        { path: 'new-material-entry', element: <MaterialEntry data={1} /> },
        { path: 'party-inward-view/:Id', element: <PartyInwView /> },
        { path: 'StitchingInfo/:Id', element: <StitchingInfo /> },
        { path: 'StitchingReturn/:Id', element: <StitchingReturn /> },
        { path: 'EmployeeEdit/:Id', element: <EmployeeEdit /> },
        { path: 'job-rate-view/:Id', element: <JobRateView /> },
        { path: 'job-rate-edit/:Id', element: <JobRateEdit /> },
        { path: 'StitchReturnInfo/:Id', element: <StitchReturnInfo /> },
        { path: 'stitch-final-return/:Id', element: <StitchFinalReturnInfo /> },
        { path: 'party-inward-edit/:Id', element: <PartyInwEdit /> },
        { path: 'party-inward-view', element: <PartyInwardView /> },
        { path: 'jobwork-payment-view/:Id', element: <JobwkPayView /> },
        { path: 'payment-entry/:Id', element: <PaymentEntry /> },
        { path: 'new-employee', element: <EmployeeEntry data={1} /> },
        { path: 'new-department', element: <DepartmentEntry data={1} /> },
        { path: 'payment-view/:Id', element: <PaymentView /> },
    ])
    return mainRoutes;
}
